module.exports = __webpack_public_path__ + "static/media/circlecontact.92f8c9c0.svg";